/**
 * Calculate the max width of the gallery
 * @param gallery
 * @param isMobile
 * @param heightMobile
 * @param heightWeb
 * @param isWidthAuto is true the width is the width of the image, if false the width is fixed to the width of the image
 * @param widthMobile
 * @param widthWeb
 * @param isFixedWidth is true the width is fixed to the width of the image
 * @param gap
 * @returns {number}
 */
export const calculateTotalWidth = ({
  gallery,
  isMobile,
  heightMobile,
  heightWeb,
  isWidthAuto = true,
  widthMobile = 343,
  widthWeb = 520,
  isFixedWidth = false,
  gap = 0,
}) => {
  if (gallery && gallery.length > 0) {
    let totalWidth = 0;
    const gapValue = gap * gallery.length;
    gallery.forEach((item) => {
      const { width, height } = item.media.staticValue;
      const fixedHeight = isMobile ? heightMobile : heightWeb;
      const fixedWidth = isMobile ? widthMobile : widthWeb;
      const widthValue = isWidthAuto ? width : fixedWidth;
      const xWidth = isFixedWidth
        ? widthValue
        : (fixedHeight * widthValue) / height;
      totalWidth += xWidth;
    });
    return totalWidth + gapValue;
  } else return 0;
};
